import View from './trip-request-sub-navigation-view';

export default View;
